// Encodes as UTF-8 bytes via TextEncoder, then base64-encodes those bytes.
// Unlike the previous encodeURIComponent/btoa approach, this never throws:
// TextEncoder substitutes a malformed lone surrogate with U+FFFD instead of
// raising, so every string input produces a result.
export const toBase64 = (value: string): string => {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};
